import React from "react";
import Button from "./base/Button.jsx";
import { CheckIcon, XMarkIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

export default function PriceItemAdminV2({ price, setPrices, prices }) {

  const [showForm, setShowForm] = React.useState(false);
  const [formData, setFormData] = React.useState(() => ({ ...price }));

  // Sync formData when price prop changes (from parent)
  React.useEffect(() => {
    setFormData({ ...price });
  }, [price.id_bdd]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeletePrice = (id_bdd) => {
    setPrices(prices.filter((p) => p.id_bdd !== id_bdd));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.price || !formData.quantity) {
      alert("Veuillez remplir au moins le nom, le prix et la quantité");
      return;
    }
    const price_updated = {
      ...formData,
      price: parseFloat(formData.price),
      quantity: parseInt(formData.quantity),
    };
    setPrices(
      prices.map((p) =>
        p.id_bdd === price_updated.id_bdd ? price_updated : p
      )
    );
    setShowForm(false);
  }

  if (!showForm) {
    return (
      <div style={styles.itemContainer}>
        <div style={styles.itemContent}>
          <p style={styles.itemName}>{price.name}</p>
          <p style={styles.itemDetails}>
            {price.quantity} places • {price.price}€
            {price.start_date && price.end_date && ` • ${price.start_date} au ${price.end_date}`}
          </p>
        </div>
        <div style={styles.itemActions}>
          <PencilSquareIcon style={styles.img} onClick={() => setShowForm(true)} />

          <TrashIcon style={styles.img} onClick={() => handleDeletePrice(price.id_bdd)} />
        </div>
      </div>
    );
  }

  return (
    <div style={styles.modal}>
      <div style={styles.modalContent}>
        <h3 style={styles.modalTitle}>Éditer le tarif</h3>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Nom du tarif</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            style={styles.input}
            placeholder="Ex: Early Bird"
          />
        </div>

        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Prix (€)</label>
            <input
              type="number"
              name="price"
              value={formData.price}
              onChange={handleChange}
              style={styles.input}
              placeholder="0"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Quantité</label>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              style={styles.input}
              placeholder="0"
            />
          </div>
        </div>

        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Date de début</label>
            <input
              type="date"
              name="start_date"
              value={formData.start_date || ""}
              onChange={handleChange}
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Date de fin</label>
            <input
              type="date"
              name="end_date"
              value={formData.end_date || ""}
              onChange={handleChange}
              style={styles.input}
            />
          </div>
        </div>

        <div style={styles.editActions}>
          <Button icon={CheckIcon} title="Enregistrer" onClick={handleSubmit} style="dark" />
          <Button icon={XMarkIcon} title="Annuler" onClick={() => setShowForm(false)} style="cancel" />
        </div>
      </div>
    </div>
  );
}

const styles = {
  itemContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 14px",
    backgroundColor: "#f3f4f6",
    borderRadius: "8px",
    marginBottom: "8px",
    minWidth: "200px",
    border: "1px solid #e5e7eb",
  },
  itemContent: {
    flex: 1,
  },
  itemName: {
    margin: "0 0 2px 0",
    fontWeight: "600",
    color: "#1f2937",
    fontSize: "14px",
  },
  itemDetails: {
    margin: "0",
    fontSize: "12px",
    color: "#6b7280",
  },
  itemActions: {
    display: "flex",
    gap: "8px",
  },
  img: {
    width: "16px",
    height: "16px",
    cursor: "pointer",
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    maxWidth: "500px",
    width: "90%",
    maxHeight: "80vh",
    overflowY: "auto",
  },
  modalTitle: {
    margin: "0 0 20px 0",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#1f2937",
  },
  formGroup: {
    marginBottom: "16px",
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  editActions: {
    display: "flex",
    gap: "8px",
    marginTop: "20px",
  },
  saveBtn: {
    flex: 1,
    padding: "10px 12px",
    backgroundColor: "#10b981",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "500",
  },
  cancelBtn: {
    flex: 1,
    padding: "10px 12px",
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "500",
  },
};
